import { render, staticRenderFns } from "./ScreenOnHold.vue?vue&type=template&id=2031e932&scoped=true"
import script from "./ScreenOnHold.vue?vue&type=script&lang=js"
export * from "./ScreenOnHold.vue?vue&type=script&lang=js"
import style0 from "./ScreenOnHold.vue?vue&type=style&index=0&id=2031e932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2031e932",
  null
  
)

export default component.exports